import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const QUESTIONNAIRES = ["ahamnon", "kodkod", "bogrim", "mapel"];
const GENDERS = [
  { value: "זכר", label: "זכר" },
  { value: "נקבה", label: "נקבה" },
  { value: "-", label: "לא צוין" },
];

const empty = { name: "", id: "", expires: "", questionnaire: "ahamnon", gender: "-" };

const validate = (form) => {
  const errors = {};
  if (!/\p{L}/u.test(form.name)) errors.name = "חובה שם עם אותיות";
  if (!/^\d+$/.test(form.id)) errors.id = "ת\"ז חייב להכיל ספרות בלבד";
  if (!form.expires || isNaN(new Date(form.expires).getTime())) errors.expires = "תאריך לא תקין";
  if (!QUESTIONNAIRES.includes(form.questionnaire)) errors.questionnaire = "שאלון לא תקין";
  return errors;
};

const AddSingleUserDialog = ({ open, onClose, onAdd }) => {
  const [form, setForm] = useState(empty);
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = () => {
    const errs = validate(form);
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    onAdd({
      id: form.id,
      name: form.name,
      username: form.id,
      expires: form.expires,
      questionnaire: form.questionnaire,
      gender: form.gender,
    });
    setForm(empty);
    setErrors({});
    onClose();
  };

  const handleClose = () => {
    setForm(empty);
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle dir="rtl">הוספת משתמש חדש</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }} dir="rtl">
          <TextField
            label="שם מלא"
            value={form.name}
            onChange={handleChange("name")}
            error={!!errors.name}
            helperText={errors.name}
            inputProps={{ dir: "rtl" }}
            fullWidth
            autoFocus
          />
          <TextField
            label='ת"ז'
            value={form.id}
            onChange={handleChange("id")}
            error={!!errors.id}
            helperText={errors.id}
            inputProps={{ dir: "ltr", inputMode: "numeric" }}
            fullWidth
          />
          <TextField
            label="תאריך תפוגה"
            type="date"
            value={form.expires}
            onChange={handleChange("expires")}
            error={!!errors.expires}
            helperText={errors.expires}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <FormControl fullWidth error={!!errors.questionnaire}>
            <InputLabel>שאלון</InputLabel>
            <Select
              value={form.questionnaire}
              label="שאלון"
              onChange={handleChange("questionnaire")}
            >
              {QUESTIONNAIRES.map((q) => (
                <MenuItem key={q} value={q}>{q}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel>מין</InputLabel>
            <Select value={form.gender} label="מין" onChange={handleChange("gender")}>
              {GENDERS.map((g) => (
                <MenuItem key={g.value} value={g.value}>{g.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>ביטול</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          הוסף משתמש
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSingleUserDialog;
